coreRouting.$inject = [
    '$urlRouterProvider',
    '$locationProvider',
    '$uiRouterProvider',
];

function coreRouting($urlRouterProvider, $locationProvider, $uiRouterProvider) {

    $urlRouterProvider.otherwise('/');
    $locationProvider.html5Mode(true).hashPrefix('!');

    const $stateRegistry = $uiRouterProvider.stateRegistry;

    $stateRegistry.register({
        name: 'root',
    });

    $stateRegistry.register({
        name: 'public',
        parent: 'root',
        abstract: true,
        middleware: [
            ['guest', 'app']
        ],
        data: {
            level: 'public'
        }
    });
}

export { coreRouting };



// WEBPACK FOOTER //
// ./src/app-core/core.routing.js